import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson26: FunctionComponent = () => {
  return (
    <div className="relative [background:linear-gradient(111.77deg,_rgba(0,_0,_0,_0),_#363636_78.54%),_#0d0d0d] w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[7.63rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset" />
      <div className="self-stretch flex flex-row items-center justify-between">
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson25"}>
          <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Back
            </b>
          </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">Fasting</b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson27"}>
          <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
            <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
              Next
            </b>
          </div>
        </a>
      </div>
      <div className="w-full flex flex-col items-center justify-center gap-[9.63rem] max-w-[125rem] text-justify text-white font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>What is Fasting?</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <span>
                  Fasting is the act of abstaining from food and/or drink for a
                  period of time. It is a practice that has been used for
                  centuries by people of all cultures and religions. There are
                  many different reasons why people fast, including religious
                  observance, spiritual enlightenment, health benefits, and
                  weight loss.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  There are many different types of fasting, each with its own
                  set of rules and guidelines. Some common types of fasting
                  include:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">{`Water fasting: `}</b>
                <span>
                  This is the most restrictive type of fasting, and involves
                  abstaining from all food and drink for a set period of time.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Intermittent fasting:</b>
                <span>
                  {" "}
                  This type of fasting involves alternating periods of eating
                  and fasting. There are many different intermittent fasting
                  protocols, but most involve eating normally for 8 hours of the
                  day and fasting for the remaining 16 hours.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">{`Eat-stop-eat: `}</b>
                <span>
                  This type of fasting involves eating normally for one day, and
                  then fasting for the next 24 hours.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Alternate-day fasting:</b>
                <span>
                  {" "}
                  This type of fasting involves alternating days of eating
                  normally with days of fasting.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>
                <span>Benefits of Fasting</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <b>Autophagy state:</b>
                <span>
                  {" "}
                  it’s a process that occurs in all cells of the body. It is a
                  natural process of cell death that helps to remove damaged and
                  unnecessary cells. When you fast, your body goes into a state
                  of autophagy, which helps to increase the rate of cell death.
                  This can help to improve your overall health and well-being.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Weight loss:</b>
                <span>
                  {" "}
                  Fasting can help you to lose weight by reducing your calorie
                  intake and increasing your metabolism. When you fast, your
                  body goes into a state of ketosis, where it starts to burn fat
                  for energy. This can lead to weight loss over time.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Improved blood sugar control: Fasting can help to improve
                  blood sugar control by reducing insulin resistance. Insulin is
                  a hormone that helps your body to use glucose for energy. When
                  you fast, your body becomes more sensitive to insulin, which
                  can help to lower your blood sugar levels.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Reduced inflammation:</b>
                <span>
                  {" "}
                  Fasting can help to reduce inflammation by reducing the
                  production of inflammatory cytokines. Cytokines are proteins
                  that are involved in the immune response. When there is too
                  much inflammation in the body, it can lead to a variety of
                  health problems, including heart disease, cancer, and
                  Alzheimer's disease.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Improved brain function:</b>
                <span>
                  {" "}
                  Fasting can help to improve brain function by increasing the
                  production of new brain cells and improving the function of
                  existing brain cells. When you fast, your body releases growth
                  factors that help to promote the growth of new brain cells.
                  These growth factors can also help to improve the function of
                  existing brain cells.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Increased energy levels:</b>
                <span>
                  {" "}
                  Fasting can help to increase energy levels by giving your body
                  a chance to rest and repair itself. When you eat, your body
                  has to work to digest and absorb the food. This can take a lot
                  of energy. When you fast, your body doesn't have to do this
                  work, so it can conserve energy for other things.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b>Improved mood:</b>
                <span>
                  {" "}
                  Fasting can help to improve mood by reducing stress and
                  anxiety. Stress and anxiety can lead to a variety of health
                  problems, including high blood pressure, heart disease, and
                  depression. Fasting can help to reduce stress and anxiety by
                  promoting relaxation and improving sleep.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>The Benefits of Fasting for the Spirit</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>Fasting can help to:</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">
                    Increase your connection with God:
                  </b>
                  <span>
                    {" "}
                    When you fast, you are giving up something that is important
                    to you. This can help you to focus on God and your
                    relationship with Him. Fasting can be a time to pray,
                    meditate, and read the Bible. It can also be a time to
                    reflect on your life and to ask God for guidance.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Increase your humility: `}</b>
                  <span>
                    Fasting can help you to realize that you are not in control
                    of everything. This can help you to be more humble and to
                    rely on God more. When you fast, you are reminded that you
                    are not self-sufficient and that you need God's help. This
                    can help you to be more grateful for what you have and to be
                    more willing to help others.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Increase your compassion:</b>
                  <span>
                    {" "}
                    Fasting can help you to understand the suffering of others.
                    This can help you to be more compassionate and to help those
                    in need. When you fast, you are reminded of the many people
                    in the world who are hungry and who do not have enough to
                    eat. This can help you to be more sympathetic to their
                    plight and to be more willing to help them.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  <b className="font-dm-sans">
                    Increase your spiritual growth:
                  </b>
                  <span>
                    {" "}
                    Fasting can help you to grow spiritually. This can help you
                    to become closer to God and to understand His will for your
                    life. When you fast, you are giving up something that is
                    important to you. This can help you to focus on God and to
                    listen to His voice. It can also help you to be more aware
                    of your own sinfulness and to need God's forgiveness.
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>
                How Fasting Can Improve Your Self-Control and Self-Discipline?
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Fasting can also help to improve your self-control and
                  self-discipline. When you fast, you are essentially training
                  yourself to resist temptation. This can be a valuable skill in
                  all areas of your life, from your diet to your finances to
                  your relationships.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Here are some of the ways that fasting can help to improve
                  your self-control and self-discipline:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">
                    It teaches you to delay gratification.
                  </b>
                  <span>
                    {" "}
                    When you fast, you are essentially saying no to something
                    that you want in the present moment in order to get
                    something that you want more in the future. This is a
                    valuable skill to learn, as it can help you to make better
                    choices in all areas of your life.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <b>&nbsp;</b>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>It helps you to build willpower.</b>
                  <span>
                    {" "}
                    Willpower is the ability to resist temptation and to stay
                    focused on your goals. Fasting can help to build willpower
                    by giving you the opportunity to practice resisting
                    temptation on a regular basis.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  <b className="font-dm-sans">{`It teaches you to focus on what is important. `}</b>
                  <span>
                    When you fast, you are forced to focus on the things that
                    are truly important to you, such as your relationship with
                    God, your health, and your relationships with others. This
                    can help you to develop a more balanced perspective on life.
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] text-[1.88rem]">
          <p className="m-0">
            <b>
              <span>
                <span>How to fast safely and effectively?</span>
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>
                <span>&nbsp;</span>
              </b>
            </span>
          </p>
          <p className="m-0 text-[1.56rem]">
            <span>
              <span>
                <b>
                  Start with short fasts and gradually increase the duration.
                </b>
                <span>
                  {" "}
                  If you are new to fasting, start with short fasts, such as 12
                  or 16 hours. As you become more comfortable with fasting, you
                  can gradually increase the duration of your fasts.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">{`Listen to your body and break your fast if you feel unwell. `}</b>
                <span>
                  If you feel lightheaded, dizzy, or nauseous while fasting,
                  break your fast. It is important to listen to your body and
                  not push yourself too hard.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Stay hydrated.</b>
                <span>
                  {" "}
                  It is important to stay hydrated while fasting. Drink plenty
                  of water, unsweetened tea, and other calorie-free beverages.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">
                  Eat a healthy diet when you are not fasting.
                </b>
                <span>
                  {" "}
                  When you are not fasting, it is important to eat a healthy
                  diet. This will help to ensure that you are getting the
                  nutrients you need.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">
                  Choose a fasting method that works for you.
                </b>
                <span>
                  {" "}
                  There are many different ways to fast, so find one that fits
                  your lifestyle and goals.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Set realistic goals. Don't try to do too much too soon. Start
                  with a short fast and gradually increase the duration as you
                  become more comfortable.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Be prepared.</b>
                <span>{` Make sure you have everything you need to make your fast successful, such as water, electrolytes, and healthy snacks. `}</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Listen to your body.</b>
                <span>
                  {" "}
                  If you feel unwell, break your fast. It's better to be safe
                  than sorry.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <b className="font-dm-sans">Don't be afraid to ask for help.</b>
                <span>
                  {" "}
                  If you're struggling with fasting, talk to a doctor or
                  registered dietitian. They can help you create a safe and
                  effective fasting plan.
                </span>
              </span>
            </span>
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>Tools to help you fast</span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  There are many different intermittent fasting apps available
                  on the app store. Some of the most popular include:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Zero:</b>
                  <span>
                    {" "}
                    This app is a great option for beginners. It is easy to use
                    and has a variety of features, such as a timer, a journal,
                    and a community forum.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Fasting Tracker:</b>
                  <span>
                    {" "}
                    This app is another great option for beginners. It is
                    similar to Zero, but it also has a few additional features,
                    such as a water tracker and a weight tracker.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Life:</b>
                  <span>
                    {" "}
                    This app is a more advanced option. It offers a variety of
                    fasting plans and features, such as a food diary and a
                    progress tracker.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  These are just a few of the many intermittent fasting apps
                  available. The best app for you will depend on your individual
                  needs and preferences.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Intermittent fasting apps can be a great way to stay on track
                  with your fasting journey. They can help you track your
                  progress, stay motivated, and learn more about fasting.
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Here are some of the ways that intermittent fasting apps can
                  help you on your fasting journey:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Track your progress:</b>
                  <span>
                    {" "}
                    Intermittent fasting apps can help you track your progress
                    by keeping track of your fasts, your weight, and your food
                    intake. This can help you stay motivated and see how your
                    fasting is impacting your health.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Stay motivated:</b>
                  <span>
                    {" "}
                    Intermittent fasting apps can help you stay motivated by
                    providing you with support from a community of other
                    fasters. This can help you stay on track when you are
                    feeling tempted to break your fast.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  <b className="font-dm-sans">{`Learn more about fasting: `}</b>
                  <span>
                    Intermittent fasting apps can help you learn more about
                    fasting by providing you with educational information and
                    resources. This can help you understand the benefits of
                    fasting and how to do it safely.
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-[1.88rem]">
            <b>
              <span>
                Why the Middle East Has Low Cancer Rates and how fasting fights
                cancer
              </span>
            </b>
          </p>
          <p className="m-0 text-gainsboro-100">
            <span>
              <b>&nbsp;</b>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  The Middle East has some of the lowest cancer rates in the
                  world. This is despite the fact that people in the Middle East
                  tend to eat a diet that is high in sugar and fat. There are a
                  number of factors that may contribute to the low cancer rates
                  in the Middle East, including:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Fasting: `}</b>
                  <span>
                    Many people in the Middle East participate in fasting during
                    the month of Ramadan. Fasting is a period of time when
                    Muslims abstain from food and drink from sunrise to sunset.
                    Fasting has been shown to have a number of health benefits,
                    including reducing inflammation, improving insulin
                    sensitivity, and boosting the immune system. All of these
                    factors may help to protect against cancer.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Spices:</b>
                  <span>
                    {" "}
                    People in the Middle East tend to use a lot of spices in
                    their cooking. Many spices have anti-cancer properties. For
                    example, turmeric has been shown to inhibit the growth of
                    cancer cells.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">{`Low tobacco use: `}</b>
                  <span>
                    Tobacco use is a major risk factor for cancer. Tobacco smoke
                    contains a number of carcinogens that can damage DNA and
                    lead to cancer. Tobacco use is relatively low in the Middle
                    East, which may help to explain the low cancer rates in the
                    region.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b className="font-dm-sans">Low alcohol consumption:</b>
                  <span>
                    {" "}
                    Alcohol consumption is also a risk factor for cancer.
                    Alcohol can damage DNA and increase the risk of developing
                    certain types of cancer. Alcohol consumption is relatively
                    low in the Middle East, which may also help to explain the
                    low cancer rates in the region.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>
                  Here are some research that shows that Middle East has low
                  cancer rates:
                </span>
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>
                  <b>{`A study published in the journal Cancer Epidemiology, Biomarkers & Prevention in 2016 found that the incidence of cancer in the Middle East is significantly lower than in Western countries. `}</b>
                  <span>
                    The study looked at data from over 100,000 people in the
                    Middle East and found that the incidence of cancer was about
                    half of what it is in Western countries.
                  </span>
                </span>
              </span>
            </li>
          </ul>
          <p className="m-0">
            <span>
              <span>
                <span>&nbsp;</span>
              </span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li>
              <span>
                <span>
                  <b>{`Another study, published in the journal Cancer Causes & Control in 2017, found that the mortality rate from cancer in the Middle East is also significantly lower than in Western countries.`}</b>
                  <span className="font-dm-sans">
                    {" "}
                    The study looked at data from over 500,000 people in the
                    Middle East and found that the mortality rate from cancer
                    was about one-third of what it is in Western countries.
                  </span>
                </span>
              </span>
            </li>
          </ul>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson27"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
      </div>
    </div>
  );
};

export default Lesson26;
